/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { getCheckFile, getUrl } from '../viewer/type/viewer-type-util';

/**
 * @import PdfViewerControllerFactory from './pdf-viewer-controller-factory'
 * @import PdfViewerSourceCreator from './pdf-viewer-source-creator'
 * @import BasePathResolver from '../basepath/basepath'
 * @import { FileSystemMapper } from '../file/system'
 * @import { ViewerType } from '../viewer/type'
 */

/**
 * Typ média PDF.
 * Soubory se lokálně ukládají a spouštějí přes `file://` protokol.
 * @implements {ViewerType}
 */
export default class PdfFileViewerType {
  /**
   * Vytvoří instanci.
   * @param {BasePathResolver} basePathResolver
   * @param {PdfViewerControllerFactory} controllerFactory
   * @param {FileSystemMapper} pathMapper
   * @param {PdfViewerSourceCreator} sourceCreator
   */
  constructor(basePathResolver, controllerFactory, pathMapper, sourceCreator) {
    this.basePathResolver = basePathResolver;
    this.controllerFactory = controllerFactory;
    this.pathMapper = pathMapper;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return this.controllerFactory.create(el, communicatorSettingsGetter);
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    return getCheckFile(medium);
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  getUrl(medium) {
    return getUrl(this.basePathResolver, medium, this.pathMapper);
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return true;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    return false;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return false;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    return false;
  }
}
